import {Directive, ElementRef, Input, OnChanges} from '@angular/core';
import {UserPreferencesService} from '../service/user-preferences.service';
@Directive({
  selector: '[appTextColor]'
})
export class TextColorDirective implements OnChanges {

  @Input() appTextColor: string;

  constructor(private el: ElementRef, private userPreferencesService: UserPreferencesService) {}

  ngOnChanges() {
    const color = (this.appTextColor === 'primary') ? this.userPreferencesService.getPrimaryTextColor() :
      this.userPreferencesService.getSecondaryTextColor();
    this.el.nativeElement.style.color = color;
  }
}
